export default __webpack_public_path__ + "static/media/humanist-777-black-bt.45dff565.ttf";